import React,{useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import { withStyles,makeStyles, useTheme } from '@material-ui/core/styles';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import {ArrowForwardIos,LastPage,AllInclusive,Add,MoreVert,Schedule,Block,Edit,Delete,People,CheckCircleOutline,NotInterested,Cancel,RemoveCircleOutline,Visibility,VisibilityOff} from '@material-ui/icons';


import {
  TableRow ,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table ,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container ,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  LinearProgress,
  FormHelperText,
  CircularProgress,
  Chip,
  isWidthUp,
  OutlinedInput,
  InputAdornment,
  Grid,
  Badge,
  Avatar
} from "@material-ui/core";

import { withLocalize,Translate } from "react-localize-redux";
import MUIDataTable from "mui-datatables";
import API from './api';

import { useSnackbar } from 'notistack';
import { setDayWithOptions } from 'date-fns/fp';

// import * as userInfo from "./login_info.js";

import UserInfo from "./login_info";

import axios from 'axios';


import {TransportService,AdminService,ReportingService} from "../../utils/web_config_2";
import { pink } from '@material-ui/core/colors';
import { set } from 'date-fns';

import {useHistory } from "react-router-dom";


import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image
} from "@react-pdf/renderer";

import MaskedInput from "react-text-mask";

import ID from '../../assets/svg/id.svg';
import { FinanceService } from '../../utils/web_config';

// mask NID 

const TextMaskCustom = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={[/[0-9]/,' ',/[0-9]/ ,/\d/, /\d/, /\d/, ' ', /[0-9]/,' ',/[0-9]/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,' ',/[0-9]/,' ',/[0-9]/,/\d/]}
      placeholderChar={'\u2000'}
      showMask
    />
  );
}

TextMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};


const StyledBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: '#44b700',
    color: '#44b700',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: '$ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}))(Badge);


const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    flexFlow:1,
    [theme.breakpoints.up('sm')]:{
      marginLeft:250,
    }
  },
  btn:{
    textTransform:"capitalize",

  },
  formTitle:{
    flexGrow:1,
},
chip:{
  margin: theme.spacing(0.5),
  textTransform:"capitalize"
}

}));




function AgentManager() {
  const classes = useStyles1();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [operatorData, setOperatorData] = useState({});
  const [userMessage,setUserMessage]=useState("Loading...");

  const history = useHistory();

  // format money 

  function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

      const negativeSign = amount < 0 ? "-" : "";

      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;

      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
      console.log(e)
    }
  };

  // stop table 


const columns = [
  {
    name: "user_id",
    label: "id",
    options: {
      display:false,
     filter: true,
     sort: true,
    }
   },
  {
   name: "names",
   label: <Translate id="operator_user.user_table.names" />,
   options: {
    filter: true,
    sort: true,
   }
  },
  {
   name: "user_phone",
   label: <Translate id="operator_user.user_table.phone" />,
   options: {
    filter: true,
    sort: false,
   }
  },
  {
    name: "agent_code",
    label: "Agent Code",
    options: {
     filter: true,
     sort: false,
    }
   },
  {
    name: "opening_balance",
   label: "Opening Balance",
   options: {
    filter: true,
    sort: false,
     customBodyRender: (value, tableMeta, updateValue) => {
       return (formatMoney(value, 0))
     }
   }
  },
  {
    name: "current_balance",
    label: "Current Balance",
    options: {
     filter: true,
     sort: true,
     customBodyRender: (value,tableMeta,updateValue)=>{
       return (formatMoney(value,0))
     }
    }
   },
   {
    name: "user_status",
    label: <Translate id="operator_user.user_table.status" />,
    options: {
     filter: true,
     sort: true,
     customBodyRender: (value, tableMeta, updateValue) => {
       console.log(value);
       if(value=="ENABLED"){
        return (
          <Chip
          variant="outlined"
          size="small"
          color="primary"
          icon={<CheckCircleOutline/>}
          label={value}
        />
            
        );
       }else if(value=="DISABLED"){
        return (
          <Chip
          variant="outlined"
          size="small"
          color="secondary"
          icon={<NotInterested/>}
          label={value}
        />
            
        );
       }else if(value=="SUSPENDED"){
         return (
          <Chip
          variant="outlined"
          size="small"
          color="secondary"
          icon={<Cancel/>}
          label={value}
        />
          );
       
       }
     
    }
    }
   }
 ];


 

 const options = {
  textLabels: {
    body: {
      noMatch: userMessage
    },
  },
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:"single",
   rowsPerPage: 10,
   elevation:0,
   selectableRowsOnClick: true,
   onCellClick: (cellData, cellMeta) => {
    var userAgentManager = users[cellMeta.dataIndex];

  

    // if (userAgentManager.agent_code == null) {
    //   enqueueSnackbar("This agent manager does not have agent code", { 
    //     variant: 'info',
    //     anchorOrigin: {
    //       vertical: 'bottom',
    //       horizontal: 'right',
    //   },
    // });
    //   return;
    // }else 



    console.log("manager",userAgentManager);
    


    if(userAgentManager==null){
      return
    }
    // if(userAgentManager.user_status!="ENABLED"){
    //   return
    // }
    history.push("/operator/agentmanegerdetails",userAgentManager);
  },
  customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
    <Box>
 
 
<Chip
  className={classes.chip}
          variant="outlined"
          size="medium"
          color="secondary"
          icon={<Edit/>}
          label={"Edit"}
          onClick={()=>{
            setUserId(displayData[selectedRows.data[0]['index']]['data'][0]);
            var id=displayData[selectedRows.data[0]['index']]['data'][0];

            var obj= users.find((o)=>o.user_id==id);
            console.log(obj);
            setEmail({value:obj.user_email,error:""});
            setFname({value:obj.user_fname,error:""});
            setLname({value:obj.user_lname,error:""});
            setGender({value:obj.user_gender,error:""});
            setNid({value:obj.user_nid,error:""});
            setPassword({value:"",error:""});
            setPhone({value:obj.user_phone,error:""});
            setPin({value:"",error:""});
            setUserType({value:obj.user_type,error:""});
            setRole({value:obj.role_id,error:""});
            setTIN({value:obj.tin,error:""});
            setEditDialog(true);

            console.log("Edit");
          }}
        />

<Chip
 className={classes.chip}
          variant="outlined"
          size="medium"
          color="secondary"
          icon={<RemoveCircleOutline/>}
          label={"Deactivate"}
          onClick={()=>{
            // console.log("data");
            // console.log(displayData[selectedRows.data[0]['index']]['data'][0]);
            // console.log(displayData[selectedRows.data[0]['index']]['data'][0]);
            setUserId(displayData[selectedRows.data[0]['index']]['data'][0]);
            setDeactiveDialog(true);
          }}
        />



<Chip
 className={classes.chip}
          variant="outlined"
          size="medium"
          color="primary"
          icon={<CheckCircleOutline/>}
          label={"Reactivate"}
          onClick={()=>{
            setUserId(displayData[selectedRows.data[0]['index']]['data'][0]);
            setActiveDialog(true);
          }}
        />



<Chip
 className={classes.chip}
          variant="outlined"
          size="medium"
          color="secondary"
          icon={<Cancel/>}
          label={"Suspend"}
          onClick={()=>{
            setUserId(displayData[selectedRows.data[0]['index']]['data'][0]);
            setSuspendDialog(true);
          }}
        />


  {/* <IconButton aria-label="Edit" onClick={()=>{
//     var index;
//     selectedRows.data.map((d)=>{
//       index=d['index'];console.log("id:"+d['index']);
//     });

//     var index;
//     selectedRows.data.map((d)=>{
//       index=d['index'];
//     });
//     var obj=stops.find((item,i) => {
//       return i == index;
//   });

    
    
  }}>
  <Edit/>
  </IconButton> */}
  
 

      </Box>
  ),
 };



  useEffect(()=>{

    var data = {};
    const data1 = localStorage.getItem("nx_op");
    if (data1 != null) {
      data = JSON.parse(data1);
      console.log("datadatadatadata",data.organization.tin_number);
    }

    setOperatorData(data);
    axios.defaults.baseURL = new AdminService().BASE_URL;

    var operatorAgentProfile = JSON.parse(localStorage.getItem("operatorAgent"));
    console.log("operatorAgent", operatorAgentProfile);


    get_users(data.token,operatorAgentProfile.agent_code);
    get_roles(data.token);

  },[]);

  /// fetch users 

  const [users,setUsers]=useState([]);
 
  const [loadUser,setUserLoad]=useState(false);
  const get_users=(token,agent_code)=>{
    setUserMessage("Loading...");
    setUserLoad(true);
    axios.defaults.baseURL = new FinanceService().BASE_URL;
    const usersInstance = axios.create(new AdminService().setHeaders(token));
    usersInstance.get('/api/v1/getAgents?parent_code=' + agent_code +"&agent_type_code=AGT-MNGR"
    ).then(res=>{
      setUserLoad(false);
      var d=res.data.data;
      if(d.length==0){
        setUserMessage("No Agent Manager available");
      }else{
        console.log("data",d);
       const data=[];
       d.map((dd)=>{
        var obj={ 	
          user_id: dd['agent_admin_id'],
          user_email: dd['email'],
          names:dd['name'],
          current_balance: dd['current_balance'],
          opening_balance: dd['opening_balance'],
          user_phone: dd['phone_number'],
          user_status: dd['status'],
          agent_code:dd['code'],
          organization_id: dd['organization_id'],
          created_date: dd['created_at']};
        data.push(obj);
       });


        setUserMessage("");
        setUsers(data);
      }
    }).catch(err=>{
      setUserMessage("Something went wrong");
      setUserLoad(false);
      console.log(err);

      if(err.message){
        enqueueSnackbar(err.message, { 
          variant: 'error',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
      });
      }
     

    if(err.response){
      if(err.response.status==401){
        history.push("/", { expired: true });
        enqueueSnackbar(err.message, { 
          variant: 'error',
      });
      }
    }
   

    });
  }






  // fetch roles

  const [roles,setRoles]=useState([]);
  const get_roles=(token)=>{
    axios.defaults.baseURL = new AdminService().BASE_URL;
    const rolesInstance = axios.create(new AdminService().setHeaders(token));
    rolesInstance.get('/api/v1/role/organization/'+new UserInfo().ORG_ID
    ).then(res=>{
      setRoles(res.data.data);
    }).catch(err=>{
      console.log(err);
    })
  
  }


// new user dialog
const [newDialog,setNewDialog]=useState(false);

// new user

const [newLoad,setNewLoad]=useState(false);
const [email,setEmail]=useState({value:"",error:""});
const [Fname,setFname]=useState({value:"",error:""});
const [Lname,setLname]=useState({value:"",error:""});
const [gender,setGender]=useState({value:"",error:""});
const [userName,setUsername]=useState({value:"",error:""});
const [nid,setNid]=useState({value:"",error:""});
const [password,setPassword]=useState({value:"",error:""});
const [phone,setPhone]=useState({value:"",error:""});
const [pin,setPin]=useState({value:"",error:""});
const [userType,setUserType]=useState({value:"",error:""});
const [role,setRole]=useState({value:0,error:""});
const [TIN,setTIN]=useState({value:operatorData?.organization?.tin_number,error:""});

const new_user=()=>{
  if(email.value===""){
    setEmail({value:"",error:"Enter email"});
  }else if(Fname.value==="" || Fname.value.length<3){
    setFname({value:"",error:"Enter first name"});
  }else if(Lname.value==="" || Lname.value.length<3){
    setLname({value:"",error:"Enter lastname"});
  }else if(userName.value==="" || userName.value.length<3){
    setUsername({value:"",error:"Enter Username"});
  }else if(NID.value===""){
    setNID({value:"",error:"Enter NID"});
  }
  
  // else if(TIN.value===0 || TIN.value===""){
  //   setTIN({value:0,error:"Enter TIN"});
  // }
  
  // else if(password.value===""){
  //   setPassword({value:"",error:"Enter password"});
  // }
  
  else if(phone.value===""){
    setPhone({value:"",error:"Enter phone"});
  }else if(role.value==0){
    setRole({value:0,error:"Select role"});
  }else{

    var data= {
      "organization_id":new UserInfo().ORG_ID,
      "role_id":role.value,
      "user_email": email.value,
      "user_first_name": Fname.value,
      "user_gender": gender.value,
      "user_last_name": Lname.value,
      "user_name": userName.value,
      "user_nid": NID.value,
      "user_phone": phone.value,
      "user_type": "AGENT_MANAGER"
    };


    

    console.log(data);
    
    setNewLoad(true);
    axios.defaults.baseURL = new AdminService().BASE_URL;
    const newInstance = axios.create(new AdminService().setHeaders(operatorData.token));
    newInstance.post('/api/v1/user/register',
    {
      "organization_id":new UserInfo().ORG_ID,
      "role_id":role.value,
      "user_email": email.value,
      "user_first_name": Fname.value,
      "user_gender": gender.value,
      "user_last_name": Lname.value,
      "user_name": userName.value,
      "user_nid": NID.value,
      "user_phone": phone.value,
      "tin":operatorData.organization.tin_number,   //TIN.value,
      "user_type": "AGENT_MANAGER"
    }
    ).then(res=>{

      var dd=res.data.data;
      var obj={
      user_id:dd['user_id'],
      user_email:dd['user_email'],
      next_password_expiry_date:dd['next_password_expiry_date'],
      names:dd['user_first_name']+" "+dd['user_last_name'],
      user_fname:dd['user_first_name'],
      user_lname:dd['user_last_name'],
      user_gender:dd['user_gender'],
      user_phone:dd['user_phone'],
      user_nid:dd['user_nid'],
      user_type:dd['user_type'],
      user_status:dd['user_status'],
      role_id:dd['role_id'],
      organization_id:dd['organization_id'],
      created_by_user_id:dd['created_by_user_id'],
      updated_by_user_id:dd['updated_by_user_id'],
      created_date:dd['created_date'],
      agent_code:dd['agent_code'],
      mod_date:dd['mod_date'],
      last_login_date:dd['ast_login_date']};

      var u=users;
      u.unshift(obj);
      setUsers(u);
      setNID({value:"",error:""});

      setNewDialog(false);
      setNewLoad(false);
      enqueueSnackbar('New Agent Manager added successifuly!', { 
        variant: 'success',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
      },
    });
    
    setManually(false);
    setUserStep(0);
    setFname({value:"",error:""});
    setLname({value:"",error:""});

    }).catch(err=>{
      setNewLoad(false);
      console.log(err);

      if(err.message){
        enqueueSnackbar(err.message ,{ 
          variant: 'error',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
      });
      }


      if(err.response){
        enqueueSnackbar(err.response.data.message ,{ 
          variant: 'error',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
      });
      }
       
    });
  }
}



// edit user dialog

const [editDialog,setEditDialog]=useState(false);

// edit user

const [editLoad,setEditLoad]=useState(false);

const edit_user=()=>{

  // if(email.value===""){
  //   setEmail({value:"",error:"Enter email"});
  // }else 
  
  
  if(Fname.value==="" || Fname.value.length<3){
    setFname({value:"",error:"Enter first name"});
  }else if(Lname.value==="" ||  Lname.value.length<3){
    setLname({value:"",error:"Enter lastname"});
  }else if(gender.value===""){
    setGender({value:"",error:"Select gender"});
  }else if(nid.value===""){
    setNid({value:"",error:"Enter NID"});
  }
  
  // else if(TIN.value===0 || TIN.value===""){
  //   setTIN({value:0,error:"Enter TIN number"});
  // }

  // else if(password.value===""){
  //   setPassword({value:"",error:"Enter password"});
  // }

  else if(phone.value===""){
    setPhone({value:"",error:"Enter phone"});
  }
  
  // else if(userType.value===""){
  //   setUserType({value:"",error:"Select Type"});
  // }
  
  else if(role.value==0){
    setRole({value:0,error:"Select role"});
  }else{
    setEditLoad(true);
    var data={
      "role_id": role.value,
      "tin": TIN.value,
      "user_email":email.value,
      "user_first_name":Fname.value,
      "user_gender":gender.value,
      "user_last_name":Lname.value,
      "user_nid": nid.value,
      "user_phone": phone.value
    };

    axios.defaults.baseURL = new AdminService().BASE_URL;
    const editInstance = axios.create(new AdminService().setHeaders(operatorData.token));
    editInstance.put('/api/v1/user/'+userId,data)
    .then(res=>{
      
      var dd=res.data.data;
      var obj={
      user_id:dd['user_id'],
      user_email:dd['user_email'],
      next_password_expiry_date:dd['next_password_expiry_date'],
      names:dd['user_first_name']+" "+dd['user_last_name'],
      user_fname:dd['user_first_name'],
      user_lname:dd['user_last_name'],
      user_gender:dd['user_gender'],
      user_phone:dd['user_phone'],
      user_nid:dd['user_nid'],
      user_type:dd['user_type'],
      user_status:dd['user_status'],
      role_id:dd['role_id'],
      organization_id:dd['organization_id'],
      created_by_user_id:dd['created_by_user_id'],
      updated_by_user_id:dd['updated_by_user_id'],
      created_date:dd['created_date'],
      mod_date:dd['mod_date'],
      last_login_date:dd['ast_login_date'],
      agent_code:dd['agent_code'],
      tin:dd['tin']};

      setNID({value:"",error:""});

      var o=users;
      var index=users.findIndex((u)=>u.user_id==userId);
      o[index]=obj;
      setUsers(o);

      setEditDialog(false);
      setEditLoad(false);

      enqueueSnackbar('User updated successful!', { 
        variant: 'success',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
      },
    });

    }).catch(err=>{
      setEditLoad(false);
      if(err.response){
        enqueueSnackbar(err.response.data.message ,{ 
          variant: 'error',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
      });
      }

      if(err.message){
        enqueueSnackbar(err.message ,{ 
          variant: 'error',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
      });
      }
      
    });
  }
}



/// dialog deactive user
const [deactiveDialog,setDeactiveDialog]=useState(false);

/// deactive user

const [userId,setUserId]=useState(0);
const [deactivateLoad,setDeactivateLoad]=useState(false);
const deactive_user=()=>{
  setDeactivateLoad(true);
  axios.defaults.baseURL = new AdminService().BASE_URL;
  const deactiveInstance = axios.create(new AdminService().setHeaders(operatorData.token));
  deactiveInstance.put('/api/v1/user/status/deactivate/'+userId
  ).then(res=>{
    setDeactiveDialog(false);
    setDeactivateLoad(false);

    var u=users.find((i)=>i.user_id==userId);
    u['user_status']="DISABLED";
    var index=users.findIndex((i)=>i.user_id==userId);
    let newArr = [...users]; 
    newArr[index] = u;


    setUsers(newArr );


    enqueueSnackbar('User deactivated successful!', { 
      variant: 'success',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
    },
  });
  }).catch(err=>{
    console.log(err);
    setDeactivateLoad(false);
    enqueueSnackbar(err.message, { 
      variant: 'error',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
    },
    });

    if(err.response){
      enqueueSnackbar(err.response.message, { 
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
      },
      });
    }
    


});   
}


// active user dialog 
const [activeDialog,setActiveDialog]=useState(false);

// active user 

const [activeLoad,setActiveLoad]=useState(false);
const active_user=()=>{
  setActiveLoad(true);
  axios.defaults.baseURL = new AdminService().BASE_URL;
  const activeInstance = axios.create(new AdminService().setHeaders(operatorData.token));
  activeInstance.put('/api/v1/user/status/reactivate/'+userId
  ).then(res=>{
    setActiveDialog(false);
    setActiveLoad(false);
   
    var u=users.find((i)=>i.user_id==userId);
    u['user_status']="ENABLED";

    var index=users.findIndex((i)=>i.user_id==userId);
  
    let newArr = [...users]; 
    newArr[index] = u;


    setUsers(newArr );
   

    enqueueSnackbar('User reactivated successful!', { 
      variant: 'success',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
    },
  });
  }).catch(err=>{
    console.log(err);
    setActiveLoad(false);

    enqueueSnackbar(err.message, { 
      variant: 'error',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
    },
    });
    // if(err.response.status==500){
    //   enqueueSnackbar('Already activated!', { 
    //     variant: 'error',
    //     anchorOrigin: {
    //       vertical: 'bottom',
    //       horizontal: 'right',
    //   },
    //   });
    // }
  })
 
}



// suspend user dialog

const [suspendDialog,setSuspendDialog]=useState(false);


// suspend user
const [suspendLoad,setSuspendLoad]=useState(false);
const suspend_user=()=>{
  setSuspendDialog(true);
  axios.defaults.baseURL = new AdminService().BASE_URL;
  const suspendInstance = axios.create(new AdminService().setHeaders(operatorData.token));
  suspendInstance.put("/api/v1/user/status/suspend/"+userId
  ).then(res=>{
    setSuspendDialog(false);
    setSuspendLoad(false);
    
    var u=users.find((i)=>i.user_id==userId);
    u['user_status']="SUSPENDED";

    var index=users.findIndex((i)=>i.user_id==userId);
  
    let newArr = [...users]; 
    newArr[index] = u;

    setUsers(newArr );

  }).catch(err=>{
setSuspendLoad(false);
enqueueSnackbar(err.message, { 
      variant: 'error',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
    },
    });
  });
}


// show password

const [showPassword,setShowPassword]=useState(false);




// get user info 


const [userStep,setUserStep]=useState(0);

const [photo,setPhoto]=useState("");

const [NID,setNID]=useState({value:"",error:""});
const [loadInfo,setLoadInfo]=useState(false);
const get_infos=()=>{
  if(NID.value==""){
    setNID({value:"",error:"Invalid ID"});
  }else if(NID.length==16){
    setNID({value:"",error:"Invalid ID"});
  }
  else{
    setLoadInfo(true);
    const data={
      "document_number": NID.value
  };
  axios.defaults.baseURL = new ReportingService().BASE_URL;
    const infoInstance = axios.create(new ReportingService().setHeaders(operatorData.token)); 
    infoInstance.post(new ReportingService().GET_NID_INFO,data)
    .then(res=>{
      setLoadInfo(false);
       var obj=res.data.data;
       if(obj.applicationNumber!=null){
        setFname({value:obj.foreName,error:""});
        setLname({value:obj.surnames,error:""});
        setPhoto(obj.photo);
        setNid({value:NID.value,error:""});
        var gender=obj.sex;
        if(gender=="M"){
          setGender({value:"MALE",error:""});
        }else if(gender=="F"){
          setGender({value:"FEMALE",error:""});
        }
      
        setUserStep(1);
       }else{
         setNID({value:"",error:"Invalid NID"});
       }
       
    })
    .catch(err=>{


    }); 
  }

 
}

const [manually,setManually]=useState(false);


  return (
    <div className={classes.root}>
      <Box display="flex">
 
 <Box display="flex" alignItems="center" mt={2} className={classes.formTitle}>
 
 <Box mr={1}><People fontSize="large" color="primary"/></Box> <Typography  variant="h5" color="default"><b>Agent Manager</b></Typography>

 </Box>
 
 <Box>
<Button  
className={classes.btn}
startIcon={<Add/>} 
onClick={()=>{
  console.log("tin_number",operatorData.organization.tin_number)
  setNewDialog(true);
 }} 
variant="contained" 
color="primary"
disableElevation={true}>

<Typography noWrap>New Agent Manager</Typography>
</Button>
</Box>
 
     </Box>

 {/* stops table  */}

 <Box mt={2}>
 {loadUser&&<LinearProgress />}
 <MUIDataTable
  title={"List of Agent Managers"}
  data={users}
  columns={columns}
  options={options}
/>
 </Box> 


{/* new user  */}


<Dialog
    maxWidth="sm"
    fullWidth
    open={newDialog}
    onClose={()=>{
      setUserStep(0);
      setNID({value:"",error:""});
      setNewDialog(false);
      setManually(false);
    }}
    aria-labelledby="new_user"
    aria-describedby="new_user"
      >

        <DialogTitle id="new_user">{"New Agent Manager"}</DialogTitle>
        <DialogContent>
          <DialogContentText >

{userStep==0&&
  <Box>

  <Box>
                <Box display="flex" justifyContent="center">
                  <img src={ID} width="100" height="100"/>
                </Box>
                <Box display="flex" justifyContent="center">
                  <Typography color="secondary">Please enter NID</Typography>
                </Box>
              <Box mt={1} display="flex">
                  <TextField 
                  autoFocus
                  style={{flexGrow:"1"}}
                  type="number"
              size='small' 
              variant='outlined' 
              error={NID.error!==""}
              helperText={NID.error}
              value={NID.value}
              onChange={(e)=>{
                var data=e.target.value;
                if(data==""){
                  setNID({value:"",error:"Invalid NID"});
                }else{
                  setNID({value:data,error:""});
                }
                
              }}

            // InputProps={{
            //   inputComponent: TextMaskCustom,
            //   onChange: (e)=>{
            //     var data=e.target.value.replace(" ","");
            //     setNID({value:data,error:""});

            //     // setScheduleTime({value:e.target.value,error:""});
            //   },
            // }}
  
            label={"National ID"}
              color='primary'  fullWidth/>
             
                
              </Box>
  
              <Box mt={1} display="flex" justifyContent="left">
                <Button style={{textTransform:"capitalize"}}  color="primary" onClick={()=>{
                setManually(true);
                setUserStep(1);
                }}>
                  Continue Manually?
                  </Button>
              </Box>
  
              </Box>
              </Box>
}

 {userStep==1&&
 
 <Box>
   {manually==false&&
   <Box>
   <Grid container>


     <Grid item  xs={6} md={12} lg={12} sm={12}>
       <Box display="flex" justifyContent="center">
       <StyledBadge
overlap="circle"
anchorOrigin={{
vertical: 'bottom',
horizontal: 'right',
}}
variant="dot"
>
<Avatar src={"data:image/png;base64,"+photo} style={{width:"100px",height:"100px"}}/>
</StyledBadge>
     
       </Box>
     </Grid>
     <Grid item xs={12} md={12} lg={12} sm={12}>
       <Box display="flex" justifyContent="center">
       <Typography size="small">{Fname.value}</Typography>
       <Typography size="small">{Lname.value}</Typography>
       </Box>
     </Grid>
   </Grid>
 </Box> 
   }
       

 <Box mt={1}>
   <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>  

   <TextField  size="small"  variant='outlined' label={"Firstname"} 
   error={Fname.error!=""}
   helperText={Fname.error}
   value={Fname.value}
   onChange={(e)=>{
     if(e.target.value==""){
       setFname({value:"",error:"Enter firstname"});
     }else{
       setFname({value:e.target.value,error:""})
     }
   }}
   color='primary'  fullWidth/>
    </FormControl>
   </Box>  


   <Box mt={1}>
   <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>  

   <TextField  size="small"  variant='outlined' label={"Lastname"} 
   error={Lname.error!=""}
   helperText={Lname.error}
   value={Lname.value}
   onChange={(e)=>{
     if(e.target.value==""){
       setLname({value:"",error:"Enter lastname"});
     }else{
       setLname({value:e.target.value,error:""})
     }
   }}
   color='primary'  fullWidth/>
    </FormControl>
   </Box> 




   <Box mt={1}>
   <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>  

   <TextField  size="small"  variant='outlined' label={"Username"} 
   error={userName.error!=""}
   helperText={userName.error}
   onChange={(e)=>{
     if(e.target.value==""){
       setUsername({value:"",error:"Enter username"});
     }else{
       setUsername({value:e.target.value,error:""})
     }
   }}
   color='primary'  fullWidth/>
    </FormControl>
   </Box>   



   <Box mt={1}>
   <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>  

   <TextField  size="small"  variant='outlined' label={"Email"} 
   error={email.error!=""}
   helperText={email.error}
   onChange={(e)=>{
     if(e.target.value==""){
       setEmail({value:"",error:"Enter email"});
     }else{
       setEmail({value:e.target.value,error:""})
     }
   }}
   color='primary'  fullWidth/>
    </FormControl>
   </Box>  



   <Box mt={1}>
   <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>  

   <TextField  size="small"  variant='outlined' label={"Phone"} 
   error={phone.error!=""}
   helperText={phone.error}
   onChange={(e)=>{
     if(e.target.value==""){
       setPhone({value:"",error:"Enter phone"});
     }else{
       setPhone({value:e.target.value,error:""})
     }
   }}
   color='primary'  fullWidth/>
    </FormControl>
   </Box>  
 
     
     
     
      {manually==true&&
      <Box mt={1}>
      <FormControl size="small" type="number" variant="outlined" fullWidth className={classes.formControl}>  
   
      <TextField  size="small"  variant='outlined' label={"NID"} 
      error={NID.error!=""}
      helperText={NID.error}
      onChange={(e)=>{
        if(e.target.value==""){
          setNID({value:"",error:"Enter NID"});
        }else{
          setNID({value:e.target.value,error:""})
        }
      }}
      color='primary'  fullWidth/>
       </FormControl>
      </Box> 
      }

 {/* tin number  */}

{/* <Box mt={1}>
      <FormControl size="small" type="number" variant="outlined" fullWidth className={classes.formControl}>  
      <TextField  size="small"  variant='outlined' label={"TIN"} 
      error={TIN.error!=""}
      helperText={TIN.error}
      value={TIN.value}
      onChange={(e)=>{
        if(e.target.value==""){
          setTIN({value:"",error:"Enter TIN"});
        }else{
          setTIN({value:e.target.value,error:""})
        }
      }}
      color='primary'  fullWidth/>
       </FormControl>
</Box>  */}
      

   
{manually==true&&
  <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
<InputLabel htmlFor="gender">Gender</InputLabel>
       <Select
       size="small"
       helperText={gender.error} 
       label="Select gender"
       inputProps={{
         name: 'gender',
         id: 'gender',
       }}
       error={gender.error!==""}
       onChange={(e)=>{
         if(e.target.value===''){
           setGender({value:"",error:"Select gender"});
         }else{
           setGender({value:e.target.value,error:""});
         }
       }}
       >
         <MenuItem value="">
           <em>None</em>
         </MenuItem>
         <MenuItem value={"MALE"}>MALE</MenuItem>
         <MenuItem value={"FEMALE"}>FEMALE</MenuItem>
       </Select>
       <FormHelperText error={gender.error!==""}>{gender.error}</FormHelperText>
     </FormControl>
</Box>
}






<Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
<InputLabel htmlFor="tole">User role</InputLabel>
       <Select
       size="small"
       helperText={role.error} 
       label="Select User role"
       inputProps={{
         name: 'role',
         id: 'role',
       }}
       error={role.error!==""}
       onChange={(e)=>{
         if(e.target.value===''){
           setRole({value:"",error:"Select user role"});
         }else{
           setRole({value:e.target.value,error:""});
         }
       }}
       >
         <MenuItem value="">
           <em>None</em>
         </MenuItem>
         {roles.map((r)=>{
           return <MenuItem value={r['role_id']}>{r['name']}</MenuItem>;
         })}
         
       </Select>
       <FormHelperText error={role.error!==""}>{role.error}</FormHelperText>
     </FormControl>
</Box>



{/* {manually==true&&
  <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
<InputLabel htmlFor="type">User Type</InputLabel>
       <Select
       size="small"
       helperText={userType.error} 
       label="Select User Type"
       inputProps={{
         name: 'type',
         id: 'type',
       }}
       error={userType.error!==""}
       onChange={(e)=>{
         if(e.target.value===''){
           setUserType({value:"",error:"Select user type"});
         }else{
           setUserType({value:e.target.value,error:""});
         }
       }}
       >
         <MenuItem value="">
           <em>None</em>
         </MenuItem>

         <MenuItem value={"ORG_USER"}>Organization User</MenuItem>
         <MenuItem value={"POS_USER"}>POS User</MenuItem>

       </Select>
       <FormHelperText error={userType.error!==""}>{userType.error}</FormHelperText>
     </FormControl>
</Box>
} */}




{/* 
<Box mt={1}>
<FormControl fullWidth  size="small"
variant="outlined">
         <InputLabel  htmlFor="password">Password</InputLabel>
         <OutlinedInput
         size="small"
           id="password"
           error={password.error!=""}
   helperText={password.error}
           type={showPassword ? 'text' : 'password'}
           value={password.value}
           onChange={(e)=>{
             if(e.target.value==""){
               setPassword({value:"",error:"Enter valid password"});
             }else{
               setPassword({value:e.target.value,error:""});
             }
           }}
           endAdornment={
             <InputAdornment position="end">
               <IconButton
                 aria-label="toggle password visibility"
                 onClick={()=>{
                   showPassword==false?setShowPassword(true):setShowPassword(false);
                   
                 }}
                 onMouseDown={(e)=>{
                   e.preventDefault();
                 }}
                 edge="end"
               >
                 {showPassword? <Visibility /> : <VisibilityOff />}
               </IconButton>
             </InputAdornment>
           }
           labelWidth={70}
         />
       </FormControl>
</Box> */}





 </Box>

 }           


          </DialogContentText>
        </DialogContent>
        
        <DialogActions>
        <Button onClick={()=>{
         setNewDialog(false);
         setNID({value:"",error:""});
         setUserStep(0);
         setManually(false);
        }} variant="outlined" color="secondary">
          Cancel
        </Button>
        {userStep==1&&
        <Button onClick={()=>{
          new_user();
        }} variant="contained" color="primary">
          {newLoad?<CircularProgress color="secondary" size={25}/>:"Save"}
        </Button>
      }

      {userStep==0&&
      <Button variant="contained" disableElevation color="primary" onClick={()=>{
        get_infos();
      }}>
       {loadInfo?<CircularProgress color="secondary" size={25}/>:"Continue"}
        </Button>}

      </DialogActions>
       
        
      </Dialog>


{/* deactive user  */}



<Dialog
    maxWidth="sm"
    fullWidth
        open={deactiveDialog}
        onClose={()=>{
          setDeactiveDialog(false);
        }}
        aria-labelledby="deactivate"
        aria-describedby="deactivate"
      >

    
        <DialogTitle id="deactivate">{"Deactivate User"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
          <Box>
        
              <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
                <Typography>Are you sure, you want to deactivate user ?</Typography>
              </Box>
      
        </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>{
            setDeactiveDialog(false);
          }} variant="outlined" color="secondary" autoFocus>
            No
          </Button>
          <Button disableElevation disabled={deactivateLoad} onClick={()=>{
            deactive_user();
          }} variant="contained" color="primary">
           {deactivateLoad?<CircularProgress size={25} color="secondary"/>:"Yes"}
          </Button>
        </DialogActions>
      </Dialog>

{/* reactive user  */}





<Dialog
    maxWidth="sm"
    fullWidth
        open={activeDialog}
        onClose={()=>{
          setActiveDialog(false);
        }}
        aria-labelledby="deactivate"
        aria-describedby="deactivate"
      >

    
        <DialogTitle id="deactivate">{"Deactivate User"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
          <Box>
        
              <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
                <Typography>Are you sure, you want to reactivate this user ?</Typography>
              </Box>
      
        </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>{
            setActiveDialog(false);
          }} variant="outlined" color="secondary" autoFocus>
            No
          </Button>
          <Button disableElevation onClick={()=>{
          active_user();
          }} variant="contained" color="primary">
           {activeLoad?<CircularProgress size={25} color="secondary"/>:"Yes"}
          </Button>
        </DialogActions>
      </Dialog>

 
 {/* suspend user  */}
 
 
<Dialog
    maxWidth="sm"
    fullWidth
        open={suspendDialog}
        onClose={()=>{
          setSuspendDialog(false);
        }}
        aria-labelledby="deactivate"
        aria-describedby="deactivate"
      >

    
        <DialogTitle id="deactivate">{"Deactivate User"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
          <Box>
        
              <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
                <Typography>Are you sure, you want to suspend this user ?</Typography>
              </Box>
      
        </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>{
             setSuspendDialog(false);
          }} variant="outlined" color="secondary" autoFocus>
            No
          </Button>
          <Button disableElevation disabled={suspendLoad} onClick={()=>{
          suspend_user();
          }} variant="contained" color="primary">
           {suspendLoad?<CircularProgress size={25} color="secondary"/>:"Yes"}
          </Button>
        </DialogActions>
      </Dialog>



{/* edit user  */}



<Dialog
    maxWidth="sm"
    fullWidth
    open={editDialog}
    onClose={()=>{
      setEditDialog(false);

    }}
    aria-labelledby="edit_user"
    aria-describedby="edit_user"
      >

        <DialogTitle id="edit_user">{"Edit Agent Manager"}</DialogTitle>
        <DialogContent>
          <DialogContentText >

  <Box>
        
  <Box mt={1}>
    <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>  

    <TextField disabled={true} size="small"  variant='outlined' label={"Firstname"} 
    error={Fname.error!=""}
    helperText={Fname.error}
    onChange={(e)=>{
      if(e.target.value==""){
        setFname({value:"",error:"Enter firstname"});
      }else{
        setFname({value:e.target.value,error:""})
      }
    }}
    value={Fname.value}
    color='primary'  fullWidth/>
     </FormControl>
    </Box>  


    <Box mt={1}>
    <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>  

    <TextField readonly={true} disabled={true}   size="small"  variant='outlined' label={"Lastname"} 
    error={Lname.error!=""}
    helperText={Lname.error}
    value={Lname.value}
    onChange={(e)=>{
      if(e.target.value==""){
        setLname({value:"",error:"Enter lastname"});
      }else{
        setLname({value:e.target.value,error:""})
      }
    }}
    color='primary'  fullWidth/>
     </FormControl>
    </Box> 




    {/* <Box mt={1}>
    <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>  

    <TextField  size="small"  variant='outlined' label={"Username"} 
    error={userName.error!=""}
    helperText={userName.error}
    onChange={(e)=>{
      if(e.target.value==""){
        setUsername({value:"",error:"Enter username"});
      }else{
        setUsername({value:e.target.value,error:""})
      }
    }}
    value={userName.value}
    color='primary'  fullWidth/>
     </FormControl>
    </Box>    */}



    <Box mt={1}>
    <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>  

    <TextField  size="small"  variant='outlined' label={"Email"} 
    error={email.error!=""}
    helperText={email.error}
    onChange={(e)=>{
      if(e.target.value==""){
        setEmail({value:"",error:"Enter email"});
      }else{
        setEmail({value:e.target.value,error:""})
      }
    }}
    value={email.value}
    color='primary'  fullWidth/>
     </FormControl>
    </Box>  



    <Box mt={1}>
    <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>  

    <TextField  size="small"  variant='outlined' label={"Phone"} 
    error={phone.error!=""}
    helperText={phone.error}
    onChange={(e)=>{
      if(e.target.value==""){
        setPhone({value:"",error:"Enter phone"});
      }else{
        setPhone({value:e.target.value,error:""})
      }
    }}
    value={phone.value}
    color='primary'  fullWidth/>
     </FormControl>
    </Box>  
  
  

    <Box mt={1}>
    <FormControl size="small" type="number" variant="outlined" fullWidth className={classes.formControl}>  

    <TextField  size="small"  variant='outlined' label={"NID"} 
    error={nid.error!=""}
    helperText={nid.error}
    onChange={(e)=>{
      if(e.target.value==""){
        setNid({value:"",error:"Enter NID"});
      }else{
        setNid({value:e.target.value,error:""})
      }
    }}
    value={nid.value}
    color='primary'  fullWidth/>
     </FormControl>
    </Box> 


   {/* tin number  */}

    {/* <Box mt={1}>
    <FormControl size="small" type="number" variant="outlined" fullWidth className={classes.formControl}>  
    <TextField  size="small"  variant='outlined' label={"TIN"} 
    error={TIN.error!=""}
    helperText={TIN.error}
    onChange={(e)=>{
      if(e.target.value==""){
        setTIN({value:"",error:"Enter TIN"});
      }else{
        setTIN({value:e.target.value,error:""})
      }
    }}
    value={TIN.value}
    color='primary'  fullWidth/>
     </FormControl>
    </Box>  */}



<Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
<InputLabel htmlFor="gender">Gender</InputLabel>
        <Select
        size="small"
        helperText={gender.error} 
        label="Select gender"
        inputProps={{
          name: 'gender',
          id: 'gender',
        }}
        error={gender.error!==""}
        onChange={(e)=>{
          if(e.target.value===''){
            setGender({value:"",error:"Select gender"});
          }else{
            setGender({value:e.target.value,error:""});
          }
        }}
        defaultValue={gender.value}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          <MenuItem value={"MALE"}>MALE</MenuItem>
          <MenuItem value={"FEMALE"}>FEMALE</MenuItem>
        </Select>
        <FormHelperText error={gender.error!==""}>{gender.error}</FormHelperText>
      </FormControl>
</Box>



<Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl} disabled={true} >
<InputLabel htmlFor="tole">User role</InputLabel>
        <Select
        size="small"
        helperText={role.error} 
        label="Select User role"
        inputProps={{
          name: 'role',
          id: 'role',
        }}
        error={role.error!==""}
        onChange={(e)=>{
          if(e.target.value===''){
            setRole({value:"",error:"Select user role"});
          }else{
            setRole({value:e.target.value,error:""});
          }
        }}
        defaultValue={role.value}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {roles.map((r)=>{
            return <MenuItem value={r['role_id']}>{r['name']}</MenuItem>;
          })}
          
        </Select>
        <FormHelperText error={role.error!==""}>{role.error}</FormHelperText>
      </FormControl>
</Box>


{/* 
<Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
<InputLabel htmlFor="type">User Type</InputLabel>
        <Select
        size="small"
        helperText={userType.error} 
        label="Select User Type"
        inputProps={{
          name: 'type',
          id: 'type',
        }}
        error={userType.error!==""}
        onChange={(e)=>{
          if(e.target.value===''){
            setUserType({value:"",error:"Select user type"});
          }else{
            setUserType({value:e.target.value,error:""});
          }
        }}
        defaultValue={userType.value}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>

          <MenuItem value={"ORG_USER"}>Organization User</MenuItem>
          <MenuItem value={"POS_USER"}>POS User</MenuItem>

        </Select>
        <FormHelperText error={userType.error!==""}>{userType.error}</FormHelperText>
      </FormControl>
</Box> */}


{/* <Box mt={1}>
<FormControl fullWidth  size="small"
variant="outlined">
          <InputLabel  htmlFor="password">Password</InputLabel>
          <OutlinedInput
          size="small"
            id="password"
            error={password.error!=""}
    helperText={password.error}
            type={showPassword ? 'text' : 'password'}
            value={password.value}
            onChange={(e)=>{
              if(e.target.value==""){
                setPassword({value:"",error:"Enter valid password"});
              }else{
                setPassword({value:e.target.value,error:""});
              }
            }}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={()=>{
                    showPassword==false?setShowPassword(true):setShowPassword(false);
                    
                  }}
                  onMouseDown={(e)=>{
                    e.preventDefault();
                  }}
                  edge="end"
                >
                  {showPassword? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
            labelWidth={70}
          />
        </FormControl>
</Box> */}

{/* 
    <Box mt={1}>
    <FormControl size="small" variant="outlined" type="password" fullWidth className={classes.formControl}>  

    <TextField  size="small" type="password" variant='outlined' label={"PIN"} 
    error={pin.error!=""}
    helperText={pin.error}
    onChange={(e)=>{
      if(e.target.value==""){
        setPin({value:"",error:"Enter PIN"});
      }else{
        setPin({value:e.target.value,error:""})
      }
    }}
    color='primary'  fullWidth/>
     </FormControl>
    </Box>  */}

  </Box>

          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>{
           setEditDialog(false);
          }} variant="outlined" color="secondary">
            Cancel
          </Button>
          <Button disabled={editLoad} onClick={()=>{
            edit_user();
          }} variant="contained" color="primary">
            {editLoad?<CircularProgress color="secondary" size={25}/>:"Save"}
          </Button>
          
        </DialogActions>
      </Dialog>

 
    </div>
  );
}

export default  withLocalize(AgentManager);